import type { ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';
import { DiagramChromeProvider } from './DiagramChromeContext';

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <DiagramChromeProvider>
      <div className="min-h-screen">
        <a href="#main" className="skip-link">
          Перейти до змісту
        </a>
        <AppSidebar />
        <div className="flex min-h-screen flex-1 flex-col">
          <AppHeader />
          <main id="main" tabIndex={-1} className="flex-1 outline-none">
            {children}
          </main>
        </div>
      </div>
    </DiagramChromeProvider>
  );
}
